import { NbDatepickerModule } from '@nebular/theme';
import { NbMomentDateModule } from '@nebular/moment';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppThemeModule } from './app-theme.module';
import { AppSettingsModule } from '@app/app-settings.module';
import { ApiModule } from '@api/core';
import { SharedModule } from '@app/shared';

import { AppComponent } from './app.component';
import { UserApiModule } from '@api/user';
import { AttachFileComponent } from './shared/attach-file/attach-file.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NbToastrModule } from '@nebular/theme';
import { FileSaverModule } from 'ngx-filesaver';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ApiModule.forRoot(),
    AppThemeModule.forRoot(),
    NbToastrModule.forRoot(),
    AppSettingsModule,
    SharedModule,
    UserApiModule,
    ReactiveFormsModule,
    FormsModule,
    FileSaverModule,
    NbDatepickerModule.forRoot(),
    NbMomentDateModule,
  ],
  bootstrap: [AppComponent],
  providers: [],
})
export class AppModule {
}
